import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useCreateOrganizationMutation } from '../../api/organizationApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import buttons from '../../styles/shared/buttons.module.css';

function slugify(name) {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export default function OrganizationCreatePage() {
  const navigate = useNavigate();
  const showToast = useToast();
  const [createOrganization, { isLoading: isCreating }] =
    useCreateOrganizationMutation();

  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: { name: '', slug: '' },
  });
  const [slugEdited, setSlugEdited] = useState(false);
  const name = watch('name');

  useEffect(() => {
    if (!slugEdited) setValue('slug', slugify(name));
  }, [name, slugEdited, setValue]);

  const onCreate = async (data) => {
    try {
      await createOrganization({
        name: data.name.trim(),
        slug: data.slug.trim(),
      }).unwrap();
      showToast('success', 'Organizations', 'Organization created.');
      navigate('/admin/organizations');
    } catch (err) {
      showToast(
        'error',
        'Organizations',
        err?.status === 409
          ? 'An organization with that slug already exists.'
          : errMsg(err, 'Could not create organization.'),
      );
    }
  };

  return (
    <EntityFormPage title="Add organization" backTo="/admin/organizations">
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Name</label>
              <InputText
                id={field.name}
                className="w-full mb-3"
                placeholder="ETH Zurich"
                {...field}
              />
            </div>
          )}
        />
        <Controller
          name="slug"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Slug (subdomain)</label>
              <InputText
                id={field.name}
                className="w-full mb-3"
                placeholder="eth-zurich"
                {...field}
                onChange={(e) => {
                  setSlugEdited(true);
                  field.onChange(e);
                }}
              />
            </div>
          )}
        />
        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isCreating} />
      </form>
    </EntityFormPage>
  );
}
